import Drawer from '@/components/basic/drawer';
import SharePanel from './share-panel-v2';
import React, {useEffect, useState} from 'react';
import {DrawerRef} from '@/components/basic/drawer/drawer';
import globalStore from '@/services/global.state';
import {shareToPlatform} from '@/common-pages/hooks/share.hooks';
import {useClipboard} from '@/common-pages/hooks/use-clipboard';
import i18n from '@/i18n';

export type ShareInfo = {
  // link 链接分享，目前这里也只有链接分享，可以不需要传type
  type?: 'link';
  // 具体的链接
  info?: string;
  tip?: string;
  inviteCode?: string;
  description?: string;
};

const SharePanelProvider = () => {
  const panelRef = React.useRef<DrawerRef>(null);
  const [shareInfo, setShareInfo] = useState<ShareInfo>();
  const {copy} = useClipboard();
  const inviteCode = shareInfo?.inviteCode || '';
  // const {shareSuccess, shareFail} = useShareToast();
  useEffect(() => {
    const sub = globalStore.shareProviderSubject.subscribe(info => {
      setShareInfo(info);
      panelRef.current?.open();
    });

    return () => {
      sub.unsubscribe();
    };
  }, []);

  const handleCopyInviteCode = () => {
    if (!inviteCode) {
      globalStore.globalWaringTotal(i18n.t('share.copyFailed'));
      return;
    }
    copy(inviteCode).then(copied => {
      if (copied) {
        panelRef.current?.close();
        globalStore.globalSucessTotal(i18n.t('share.copy-success'));
      } else {
        globalStore.globalWaringTotal(i18n.t('share.copyFailed'));
      }
    });
  };

  return (
    <Drawer
      mode="bottom"
      zIndex={10000}
      ref={panelRef}
      contentBackgroundColor="transparent">
      <SharePanel
        hasReward={false}
        inviteCode={inviteCode}
        description={shareInfo?.description}
        onCopyInviteCode={handleCopyInviteCode}
        onClose={() => panelRef.current?.close()}
        onItemPress={async platform => {
          const copied = await shareToPlatform(
            platform,
            shareInfo?.info || '',
            shareInfo?.tip,
          );
          if (copied !== false) {
            panelRef.current?.close();
          }
        }}
      />
    </Drawer>
  );
};

export default SharePanelProvider;
